import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import * as React from 'react';
import { highlightTermsInHtmlElement } from 'owa-mail-highlight-terms';
import LocationWrapper from './LocationWrapper';

const styles = require('./MeetingDetails.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MeetingDetailsLocationProps {
    item: MeetingRequestMessageType;
    className?: string;
    iconStyle?: string;
}

@observer
export default class MeetingDetailsLocation extends React.Component<
    MeetingDetailsLocationProps,
    {}
> {
    render() {
        const { item, className, iconStyle } = this.props;

        if (!item) {
            return null;
        }

        const conditionalDetailsStyles = {
            cancelled: item.ItemClass.match(/^ipm\.schedule\.meeting\.canceled/i),
        };

        return item.Location && item.Location.DisplayName ? (
            <div
                className={classNames(styles.detailsRow, className)}
                onClick={this.onClick}
                ref={this.highlightMeetingLocation}>
                <Icon className={classNames(styles.icon, iconStyle)} iconName={ControlIcons.Poi} />
                <span className={classNames(styles.locationDetails, conditionalDetailsStyles)}>
                    <LocationWrapper item={item} className={className} />
                    {item.ChangeHighlights && item.ChangeHighlights.Location && (
                        <span className={styles.change}>{item.ChangeHighlights.Location}</span>
                    )}
                </span>
            </div>
        ) : null;
    }

    private onClick(evt: React.MouseEvent<HTMLDivElement>) {
        evt.stopPropagation();
    }

    private highlightMeetingLocation(ref: HTMLDivElement) {
        highlightTermsInHtmlElement(ref);
    }
}
